// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 600px){.weeks-navigation__mobile[data-v-1e145f40]{display:none}}@media (max-width: 599px){.weeks-navigation__desktop[data-v-1e145f40]{display:none}}.weeks-navigation__desktop__label[data-v-1e145f40]{font-weight:bolder;font-size:21px;padding:0}\n", ""]);
// Exports
module.exports = exports;
